import React from 'react'
import { Button, Form } from 'react-bootstrap'
import { StyledDragDropFileUploader, StyledFileUploaderError, StyledSelectedFiles } from './DragDropFileUploader.styled'

interface ISelectedDocument {
  fileName: string
}

interface IProps {
  accept: string
  emptyText: string
  errorMessage?: string
  fileInputRef: React.RefObject<HTMLInputElement>
  isDisabled: boolean
  isDragActive: boolean
  selectedDocuments: ISelectedDocument[]
  onDragLeave: (event: React.DragEvent<HTMLDivElement>) => void
  onDragOver: (event: React.DragEvent<HTMLDivElement>) => void
  onDrop: (event: React.DragEvent<HTMLDivElement>) => void | Promise<void>
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>
  onRemoveDocument: (index: number) => void
}

export const DragDropFileUploader: React.FC<IProps> = ({
  accept,
  emptyText,
  errorMessage,
  fileInputRef,
  isDisabled,
  isDragActive,
  selectedDocuments,
  onDragLeave,
  onDragOver,
  onDrop,
  onFileChange,
  onRemoveDocument
}) => {
  const openFilePicker = () => {
    if (!isDisabled) {
      fileInputRef.current?.click()
    }
  }

  return (
    <>
      <StyledDragDropFileUploader
        isDragActive={isDragActive}
        isDisabled={isDisabled}
        onClick={openFilePicker}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        role="button"
        tabIndex={isDisabled ? -1 : 0}
        onKeyDown={(event) => {
          if ((event.key === 'Enter' || event.key === ' ') && !isDisabled) {
            event.preventDefault()
            openFilePicker()
          }
        }}
      >
        <div className="dropzone-content">
          <div className="dropzone-title">{emptyText}</div>
        </div>
      </StyledDragDropFileUploader>

      <Form.Control
        ref={fileInputRef}
        type="file"
        multiple
        accept={accept}
        onChange={onFileChange}
        disabled={isDisabled}
        className="d-none"
      />

      {errorMessage && <StyledFileUploaderError>{errorMessage}</StyledFileUploaderError>}

      {selectedDocuments.length > 0 && (
        <StyledSelectedFiles>
          <div className="pending-upload-block">
            <ul className="uploaded-document-list">
              {selectedDocuments.map((document, index) => (
                <li key={`${document.fileName}-${index}`} className="uploaded-document-item">
                  <span className="uploaded-document-name" title={document.fileName}>
                    {document.fileName}
                  </span>
                  <Button
                    variant="link"
                    size="sm"
                    className="text-danger remove-document-button"
                    onClick={() => onRemoveDocument(index)}
                  >
                    Remove
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        </StyledSelectedFiles>
      )}
    </>
  )
}
